import React from 'react';
import { TopBar } from '../components/TopBar';
import { Hero } from '../components/Hero';
import { PainPoints } from '../components/PainPoints';
import { Mechanism } from '../components/Mechanism';
import { Timeline21Days } from '../components/Timeline21Days';
import { WhatIncludes } from '../components/WhatIncludes';
import { OfferSection } from '../components/OfferSection';
import { Benefits } from '../components/Benefits';
import { Testimonials } from '../components/Testimonials';
import { Objections } from '../components/Objections';
import { FAQ } from '../components/FAQ';
import { FinalCTA } from '../components/FinalCTA';
import { StickyCTA } from '../components/StickyCTA';
export function LandingPage() {
  return <div className="min-h-screen flex flex-col font-sans" data-id="element-212">
      {/* Tracking Placeholders */}
      {/* TODO: Add Meta Pixel ID */}
      {/* TODO: Add GA/GTM tracking */}

      <TopBar data-id="element-213" />

      <main className="flex-grow" data-id="element-214">
        <Hero data-id="element-215" />
        <PainPoints data-id="element-216" />
        <Mechanism data-id="element-217" />
        <Timeline21Days data-id="element-218" />
        <WhatIncludes data-id="element-219" />
        <OfferSection data-id="element-220" />
        <Benefits data-id="element-221" />
        <Testimonials data-id="element-222" />
        <Objections data-id="element-223" />
        <FAQ data-id="element-224" />
        <FinalCTA data-id="element-225" />
      </main>

      <footer className="bg-[#1a0625] text-white/30 py-8 text-center text-sm" data-id="element-226">
        <p data-id="element-227">
          © {new Date().getFullYear()} El Secreto de la Abundancia. Todos los
          derechos reservados.
        </p>
      </footer>

      <StickyCTA data-id="element-228" />
    </div>;
}